import React from 'react';

import { HowToHelpType, OnlineHelp } from '@shared/enums';

import BananasIcon from '@shared/icons/bananas';
import BreadIcon from '@shared/icons/bread';
import CerealsIcon from '@shared/icons/cereals';
import EggIcon from '@shared/icons/egg';
import FishIcon from '@shared/icons/fish';
import FlourIcon from '@shared/icons/flour';
import JuiceIcon from '@shared/icons/juice';
import MeatIcon from '@shared/icons/meat';
import MilkIcon from '@shared/icons/milk';
import OilIcon from '@shared/icons/oil';
import PastaIcon from '@shared/icons/pasta';
import PotatoesIcon from '@shared/icons/potatoes';
import TomatoesIcon from '@shared/icons/tomatoes';
import WaterIcon from '@shared/icons/water';

export interface GoodExample {
  value: string;
  label: React.FunctionComponent;
}

export const getIntegrationGoods = () =>
  ({
    [HowToHelpType.OnlineFood]: {
      200: [
        {
          value: 'Bread',
          label: BreadIcon,
        },
        {
          value: 'Eggs',
          label: EggIcon,
        },
        {
          value: 'Сereals',
          label: CerealsIcon,
        },
        {
          value: 'Potatoes',
          label: PotatoesIcon,
        },
        {
          value: 'Vegetable Oil/Butter',
          label: OilIcon,
        },
        {
          value: 'Water',
          label: WaterIcon,
        },
      ],
      500: [
        {
          value: 'Bread',
          label: BreadIcon,
        },
        {
          value: 'Eggs',
          label: EggIcon,
        },
        {
          value: 'Сereals',
          label: CerealsIcon,
        },
        {
          value: 'Potatoes',
          label: PotatoesIcon,
        },
        {
          value: 'Vegetable Oil/Butter',
          label: OilIcon,
        },
        {
          value: 'Water',
          label: WaterIcon,
        },
        {
          value: 'Bananas',
          label: BananasIcon,
        },
        {
          value: 'Tomatoes',
          label: TomatoesIcon,
        },
        {
          value: 'Milk',
          label: MilkIcon,
        },
        {
          value: 'Pasta',
          label: PastaIcon,
        },
      ],
      1000: [
        {
          value: 'Bread',
          label: BreadIcon,
        },
        {
          value: 'Eggs',
          label: EggIcon,
        },
        {
          value: 'Сereals',
          label: CerealsIcon,
        },
        {
          value: 'Potatoes',
          label: PotatoesIcon,
        },
        {
          value: 'Vegetable Oil/Butter',
          label: OilIcon,
        },
        {
          value: 'Water',
          label: WaterIcon,
        },
        {
          value: 'Bananas',
          label: BananasIcon,
        },
        {
          value: 'Tomatoes',
          label: TomatoesIcon,
        },
        {
          value: 'Milk',
          label: MilkIcon,
        },
        {
          value: 'Pasta',
          label: PastaIcon,
        },
        {
          value: 'Juice',
          label: JuiceIcon,
        },
        {
          value: 'Meat',
          label: MeatIcon,
        },
        {
          value: 'Fish',
          label: FishIcon,
        },
        {
          value: 'Flour',
          label: FlourIcon,
        },
      ],
    },

    [HowToHelpType.OnlineMedicaments]: {},

    [HowToHelpType.OnlineFuel]: {},
  } as Record<OnlineHelp, Record<number, GoodExample[]>>);
